import { useEffect, useState, useMemo } from "react";
import "./HomePage.css";
import { createLogger } from "../../../../utils/logger";

const logger = createLogger('HomePage');

import Sidebar from "./Sidebar";
import { NoteBook } from "../../../../model/models";
import { Outlet } from "react-router-dom";
import NewNotebookModal from "./NewNotebookModal";

import HomeHeader from "./header/HomeHeader";
import {notebookService} from '../../../../App';

import { useDispatch } from "react-redux";
import { storeNotebooks } from "../../../../slice/notebooksSlice";

let responseNotebooks;

const HomePage = () => {

  const [notebooks, setNotebooks] = useState([]);

  //redux
  // @ts-ignore
  //const count = useSelector((state) => state.counter.value)
  // The `state` arg is correctly typed as `RootState` already
  //const count = useAppSelector((state) => state.home.value)
  
  //const dispatch = useAppDispatch()
  // @ts-ignore
  //const currentNotebook = useSelector((state) => state.notebook.value)
  const dispatch = useDispatch()

  const [showNewNotebookDialog, setShowNewNotebookDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        responseNotebooks = await notebookService.readNotebooksByOwner(1);
        setNotebooks(responseNotebooks);    
        dispatch(storeNotebooks(responseNotebooks));
      } catch (error) {
        logger.error(error);
      }
    };

    fetchData();
  }, []);

  /** callback for filtering */
  const onFilterNotebooks = async (filter: string) => {
    logger.debug(
      `onFilterNotebooks using:${filter} with noteBooks:${notebooks}`
    );
    setNotebooks(
      responseNotebooks.filter((e: NoteBook) => {
        return e.name.toLowerCase().includes(filter.toLowerCase());
      })
    );
  };

  // Memoize context object to prevent unnecessary child re-renders (rerender-memo-with-default-value)
  const appContext = useMemo(() => ({
    onNotebookSelected: (notebook: NoteBook) => {
      logger.debug(`appContext onNotebookSelected ${JSON.stringify(notebook)}`);
    },
    onNewNoteboookSelected: () => {
      setShowNewNotebookDialog(true);
    },
  }), []);


  return (
    <>
      <div className="page-container ">
        <Sidebar
          context={appContext}
          notebooks={notebooks}
          onFilterNotebooks={onFilterNotebooks}
        />
        <div className="page">
          <HomeHeader />
          <div className="content">
            <NewNotebookModal
              show={showNewNotebookDialog}
              handleClose={async (response) => {
                setShowNewNotebookDialog(false);
                if (response?.success === true) {
                  // reload data to show the new notebook
                  responseNotebooks =
                    await notebookService.readNotebooksByOwner(1);
                  setNotebooks(responseNotebooks);
                }
              }}
            />
            <Outlet/>
          </div>
          <div className="footer"></div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
